var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAm001CircleUncheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 20,
    height: 20,
    rx: 3,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 4.254C7.444 4.254 4.574 7.124 4.574 10.68C4.574 14.236 7.444 17.106 11 17.106C14.556 17.106 17.426 14.236 17.426 10.68C17.426 7.124 14.556 4.254 11 4.254ZM11 5.976C13.59 5.976 15.704 8.09 15.704 10.68C15.704 13.27 13.59 15.384 11 15.384C8.41 15.384 6.296 13.27 6.296 10.68C6.296 8.09 8.41 5.976 11 5.976Z",
    fill: "#333333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 20,
    height: 20,
    rx: 3,
    stroke: "#E7ECEF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAm001CircleUncheck);
export default __webpack_public_path__ + "static/media/am-001-circle-uncheck.fcfd28d20899043a25fbc156137d4ce6.svg";
export { ForwardRef as ReactComponent };